// import cx from "classnames";
import React from "react";
// import Filter from "../../Filter";
import Select from "react-select-new";

// A simple filter which filters on provided text
export const AutocompleteFilter = (props) => {
    let options =
        props?.filterOptions?.contextIdentifier && props?.contextData?.[props.filterOptions.contextIdentifier]
            ? props.contextData[props.filterOptions.contextIdentifier]
            : props?.filterOptions?.options || [];

    let selected = options?.find((o) => o.value === props.state);

    // <Filter
    //     title={props.title}
    //     filterName={props?.filterOptions?.filterIdentifier || props.columnIdentifier}
    //     filters={props.contextData?.[props.filterOptions.contextIdentifier] || []}
    //     noTitle={props?.noTitle || props?.filterOptions?.noTitle || true}
    //     key={props.columnIdentifier}
    //     className={cx("text-filter", props.className)}
    //     type={"dropdown"}
    //     placeholder={props.placeholder}
    //     handleFilter={(name, value) => props.setFilter(props?.filterOptions?.filterIdentifier || props.columnIdentifier, value)}
    //     activeFilters={props.filterState || {}}
    // />

    return (
        <Select
            name={props?.columnIdentifier}
            value={selected || ""}
            className="full-width-labels table-head--dropdown"
            onChange={(e) => props.setFilter(props.columnIdentifier, e?.value || null)}
            controlShouldRenderValue={true}
            options={options}
            getOptionLabel={(o) => o.name}
            getOptionValue={(o) => o.value}
            isClearable={true}
            backspaceRemovesValue={true}
            placeholder={props.placeholder}
            noOptionsMessage={() => "Geen resultaten"}
        />
    );
};
